export default __webpack_public_path__ + "static/media/Wordpress_Home_1Tower_Window_Cleaning.0f20f8f6.png";